export default function extendAlpine(Alpine) {
    // Add new methods for manipulating data
    let datas;

    Object.defineProperty(Alpine, 'getData', {
        value: (name) => (name ? datas[name] : datas),
    });

    Object.defineProperty(Alpine, 'deleteData', {
        value: (name) => delete datas[name],
    });

    Object.defineProperty(Object.prototype, '__alpineDatas', {
        configurable: true,
        set() {
            datas = this;
        },
    });

    Alpine.data('__alpineDatas', {});

    delete Object.prototype.__alpineDatas;

    // Remove shorthands
    let attributeTransformers;

    for (let i = 0; i < 3; i++) {
        Object.defineProperty(Array.prototype, i, {
            configurable: true,
            set() {
                attributeTransformers = this;
            },
        });
    }

    Alpine.mapAttributes('dummy');

    attributeTransformers.splice(0);
    Array.prototype.splice(0);
}
